/**
 * Onboarding completion flag.
 *
 * One-shot per browser: completing or skipping the wizard marks it done so a
 * reload lands straight in the library. The wizard itself still only appears
 * when there is something to set up (see App.tsx), so a second device where
 * everything is already configured never sees it.
 */

const ONBOARDING_KEY = 'jnote.onboarding.done.v1';

/** Exported for the config-backup importer (same key, single source). */
export const ONBOARDING_DONE_KEY = ONBOARDING_KEY;

function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function isOnboardingDone(): boolean {
  return storage()?.getItem(ONBOARDING_KEY) === '1';
}

export function markOnboardingDone(): void {
  try {
    storage()?.setItem(ONBOARDING_KEY, '1');
  } catch {
    // Private mode / quota: degrade to "show again next time".
  }
}
